import { Component, Input, forwardRef } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
  selector: "app-currency-input",
  template: `
    <mat-form-field appearance="outline">
      <input
        matInput
        [options]="currencyOptions"
        currencyMask
        [ngModel]="value"
        (ngModelChange)="onModelChange($event)"
        (blur)="onTouched()"
      />
    </mat-form-field>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CurrencyInputComponent),
      multi: true,
    },
  ],
})
export class CurrencyInputComponent implements ControlValueAccessor {
  @Input() currencyOptions: any; // Opciones personalizadas de currencyMask
  value: any;

  onTouched: () => void = () => {};
  onModelChange: (value: any) => void = () => {};

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onModelChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
